import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface PackageFranchiseeNoteProps {
  /** `franchiseeDiscountPercent`: el descuento EXTRA para franquiciatarias. */
  percent: number;
}

/**
 * El aviso de que este paquete tiene descuento extra para quien tenga
 * franquicia digital.
 *
 * ── Es literalmente lo que pide el documento ─────────────────────────
 * «En el wizard de paquetes personales, un aviso: "este paquete tiene un
 * 10% de descuento para franquiciatarios" + botón de adquirir
 * franquicia». Aparece antes, en la tarjeta, porque es donde se está
 * comparando el precio — que es cuando el dato pesa.
 *
 * ── Sin gritar ───────────────────────────────────────────────────────
 * Una línea de texto con un enlace, no un banner ni un botón primario.
 * Desde el 14-sep-2026 TODO paquete lo tiene (el 10 % general, o el
 * suyo con `franchiseeDiscountPercent`), así que se pinta en todas las
 * tarjetas para quien aún no tiene franquicia; a quien la tiene, la
 * tarjeta le enseña el precio ya rebajado y este aviso no aparece.
 *
 * El enlace va a `/franquicias`, que existe.
 */
export function PackageFranchiseeNote({ percent }: PackageFranchiseeNoteProps) {
  const { t } = useTranslation();

  return (
    <p className="text-[13px] leading-relaxed text-ds-ink-3">
      {t("Con franquicia digital, un {{n}}% menos en este paquete.", { n: percent })}{" "}
      <Link
        to="/franquicias"
        className="inline-flex items-center gap-0.5 font-semibold text-ds-violet-pop underline decoration-ds-violet-pop/30 underline-offset-2 hover:decoration-ds-violet-pop focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-violet-pop/50 focus-visible:ring-offset-2"
      >
        {t("Ver franquicias")}
        <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
      </Link>
    </p>
  );
}
